import { create } from 'zustand';
import { tagsApi } from '../lib/api';
import type { Tag } from '../types/tag';

const key = (kind: string, id: string) => `${kind}:${id}`;

interface TagState {
  byRecord: Record<string, Tag[]>;
  loadForRecord: (kind: string, id: string) => Promise<void>;
  apply: (kind: string, id: string, tag: Tag) => Promise<void>;
  remove: (kind: string, id: string, tag: Tag) => Promise<void>;
}

export const useTagStore = create<TagState>((set, get) => ({
  byRecord: {},
  loadForRecord: async (kind, id) => {
    const tags = await tagsApi.forRecord(kind, id);
    set((s) => ({ byRecord: { ...s.byRecord, [key(kind, id)]: tags } }));
  },
  apply: async (kind, id, tag) => {
    const k = key(kind, id);
    const prev = get().byRecord[k] ?? [];
    set((s) => ({ byRecord: { ...s.byRecord, [k]: [...prev, tag] } }));
    try {
      await tagsApi.apply(tag.id, kind, id);
    } catch (e) {
      set((s) => ({ byRecord: { ...s.byRecord, [k]: prev } }));
      throw e;
    }
  },
  remove: async (kind, id, tag) => {
    const k = key(kind, id);
    const prev = get().byRecord[k] ?? [];
    set((s) => ({ byRecord: { ...s.byRecord, [k]: prev.filter((t) => t.id !== tag.id) } }));
    try {
      await tagsApi.remove(tag.id, kind, id);
    } catch (e) {
      set((s) => ({ byRecord: { ...s.byRecord, [k]: prev } }));
      throw e;
    }
  },
}));
